import { render } from "./ListeCorrectionRequest.vue?vue&type=template&id=c9b22e14&scoped=true&ts=true"
import script from "./ListeCorrectionRequest.vue?vue&type=script&lang=ts"
export * from "./ListeCorrectionRequest.vue?vue&type=script&lang=ts"

import "./ListeCorrectionRequest.vue?vue&type=style&index=0&id=c9b22e14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9b22e14"]])

export default __exports__